import { getService } from "../../reducers/service";
import { serviceNames } from "../../utils/constants";

export const getChecklistItemData = async (id) => {
	const service = await getService(serviceNames.perChecklistItems);
	return service.find({
		query: {
			id,
			isDeleted: false,
		},
	});
};

export const updateChecklistItemData = async (id, data) => {
	const service = await getService(serviceNames.perChecklistItems);
	const response = await service.patch(id, data);
	return response;
};

export const getInspectionTypeOptions = async (dictionary) => {
	const codePerInspectionTypes = dictionary?.codePerInspectionTypes || [];

	if (codePerInspectionTypes.length > 0) {
		return codePerInspectionTypes.map((type) => ({
			label: type?.Code || type?.code,
			value: type?.ptsCodeId || type?.id || type?.Code,
		}));
	}

	return [];
};
